"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponentThemes = _interopRequireDefault(require("../../../_nextgen/packages/styled-component-themes"));
var _analytics = require("../../analytics");
var _V = _interopRequireDefault(require("./V3"));
var themes = _interopRequireWildcard(require("./index.themes"));
const Spec = (0, _analytics.withAnalytics)((0, _styledComponentThemes.default)(_V.default, themes))();
var _default = exports.default = Spec;